import { PublicClientApplication } from '@azure/msal-browser';

import { loginRequest, msalConfig } from "../../authConfig";


export const msalInstance = new PublicClientApplication(msalConfig);

/**
 * function for login
 */
export const handleLogin = () => {
    msalInstance.loginRedirect(loginRequest)
        .catch(error => console.log(error));
}

/**
 * function for logout
 */
export const handleLogout = () => {
    msalInstance.logoutRedirect()
        .catch(error => console.log(error));
}

/**
 *  Get access token 
 */
export const getAccessToken = async () => {

    const accounts = msalInstance.getAllAccounts();

    // Handle case where no account is logged in
    if (!accounts || accounts.length === 0) {
        console.warn('[Auth] No user account found. User needs to log in.');
        return null;
    }

    const request = {
        ...loginRequest,
        account: accounts[0]
    }

    try {
        console.log('[Auth] Attempting silent token acquisition...');
        const response = await msalInstance.acquireTokenSilent(request);
        console.log('[Auth] Token acquired successfully');
        return response.accessToken;
    } catch (error) {
        console.warn('[Auth] Silent token acquisition failed:', error.errorCode || error.message);
        
        // Check if this is an interaction required error
        if (error.errorCode === 'interaction_required' || 
            error.errorCode === 'consent_required' ||
            error.errorCode === 'login_required') {
            console.log('[Auth] Triggering interactive token acquisition...');
            try {
                await msalInstance.acquireTokenRedirect(request);
                // Note: acquireTokenRedirect doesn't return - page will reload
                return null;
            } catch (redirectError) {
                console.error('[Auth] Token redirect failed:', redirectError);
                return null;
            }
        }
        
        console.error('[Auth] Token acquisition failed:', error);
        return null;
    }
}

/**
 *  Get LDAP Id
 */
export const getLdapId = () => {

    const accounts = msalInstance.getAllAccounts();
    if (!accounts || accounts.length === 0) {
        console.warn('[Auth] No account found when getting LDAP ID');
        return null;
    }
    const username = accounts[0].username;
    return username.slice(0, username.lastIndexOf('@'));
}

/**
 * Check if user is authenticated and get account info
 */
export const getAuthenticationStatus = () => {
    const accounts = msalInstance.getAllAccounts();
    return {
        isAuthenticated: accounts && accounts.length > 0,
        accountCount: accounts?.length || 0,
        account: accounts?.[0] || null
    };
}

/**
 * Initialize MSAL and handle redirect response
 */
export const initializeMsal = async () => {
    try {
        console.log('[Auth] Initializing MSAL...');
        await msalInstance.initialize();
        const response = await msalInstance.handleRedirectPromise();
        if (response) {
            console.log('[Auth] Redirect response received:', response);
        }
        const status = getAuthenticationStatus();
        console.log('[Auth] Authentication status:', status);
        return response;
    } catch (error) {
        console.error('[Auth] MSAL initialization error:', error);
        throw error;
    }
}